<template>
  <div id="app" class="flex flex-col min-h-screen bg-gradient-to-br from-[#10103c] via-[#1a1a5c] to-[#2a2a7c]">
    <Navbar />
    <main class="flex-grow min-h-[calc(100vh-150px)]">
      <router-view />
    </main>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
import emitter from '@/eventBus'

export default {
  name: 'App',
  components: {
    Navbar
  },
  data() {
    return {
      detectedLanguage: false
    }
  },
  mounted() {
    emitter.on('language-detected', (data) => {
      this.detectedLanguage = true;
              if (process.env.NODE_ENV === 'development') {
          console.log('Language auto-detected:', data);
        }
    });
    
    // Ensure loading screen is hidden when Vue app is fully mounted
    this.$nextTick(() => {
      setTimeout(() => {
        const loadingScreen = document.getElementById('initial-loading');
        if (loadingScreen) {
          loadingScreen.classList.add('fade-out');
          setTimeout(() => {
            if (loadingScreen.parentNode) {
              loadingScreen.parentNode.removeChild(loadingScreen);
            }
          }, 500);
        }
      }, 200);
    });
  },
  beforeUnmount() {
    emitter.off('language-detected');
  }
}
</script>

<style>
/* Ensure consistent dark background across the app */
#app {
  background: linear-gradient(135deg, #10103c 0%, #1a1a5c 50%, #2a2a7c 100%);
  min-height: 100vh;
}

/* Ensure smooth transitions */
* {
  transition: background-color 0.3s ease;
}
</style> 